export default __webpack_public_path__ + "938841c.png";